var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa24X16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0267 5C13.6067 5 12.3376 5.68151 12.3376 6.94067C12.3376 8.38467 14.5883 8.48441 14.5883 9.20984C14.5883 9.51529 14.2103 9.78871 13.5646 9.78871C12.6482 9.78871 11.9633 9.40666 11.9633 9.40666L11.6702 10.6773C11.6702 10.6773 12.4592 11 13.5067 11C15.0593 11 16.281 10.285 16.281 9.00434C16.281 7.47849 14.0209 7.38171 14.0209 6.70839C14.0209 6.46912 14.3313 6.20695 14.9751 6.20695C15.7016 6.20695 16.2943 6.4848 16.2943 6.4848L16.5811 5.2576C16.5811 5.2576 15.9362 5 15.0267 5ZM2.03439 5.09262L2 5.27786C2 5.27786 2.59743 5.3791 3.13551 5.58104C3.82834 5.81261 3.87769 5.94742 3.99437 6.36614L5.26586 10.9045H6.9703L9.59612 5.09262H7.89559L6.20835 9.04414L5.51985 5.69465C5.45671 5.3113 5.13688 5.09262 4.74539 5.09262H2.03439ZM10.2799 5.09262L8.94592 10.9045H10.5675L11.8968 5.09262H10.2799ZM19.3242 5.09262C18.9331 5.09262 18.726 5.28646 18.5739 5.62518L16.1982 10.9045H17.8987L18.2277 10.0246H20.2995L20.4995 10.9045H22L20.691 5.09262H19.3242ZM19.5453 6.66281L20.0494 8.8437H18.699L19.5453 6.66281Z",
    fill: "#1434CB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 15,
    rx: 1.5,
    stroke: "black",
    strokeOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa24X16);
export default __webpack_public_path__ + "static/media/visa24x16.f25ba45cc8c2c6cae16e601e7dc7ee28.svg";
export { ForwardRef as ReactComponent };